export function checkImageURI(uri) {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => resolve(true); // Image exists
    img.onerror = () => resolve(false); // Image does not exist
    img.src = uri;
  });
}
